import TornadoIcon from "@mui/icons-material/Tornado";
import { styled } from "@mui/material/styles";

const StyledTornadoIcon = styled(TornadoIcon)(({ theme }) => ({
  color: "#21CCFB",
  fontSize: theme.typography.pxToRem(20), // "small" is 20px in MUI
}));

export default StyledTornadoIcon;
